<template>
  <el-select
    v-model="value"
    placeholder="Estado De Objetivo"
    @change="OnPendingChange"
    size="mini"
    clearable
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "PendingCompletedTasksFilter",
  props: {
    initialValue: {
      type: String
    }
  },
  data() {
    return {
      options: [
        // { value: null, label: "Todas" },
        { value: true, label: "Pendientes" },
        { value: false, label: "Completadas" }
      ],
      value: null
    };
  },
  methods: {
    OnPendingChange(value) {
      this.$emit("PendingFilterChange", value);
    }
  }
};
</script>

<style lang="scss" scoped></style>
